// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file gitpod/v1/integration.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { PaginationRequest, PaginationResponse } from "./pagination_pb.js";

/**
 * IntegrationDefinition defines a service that can be integrated with
 * (e.g. Linear, GitHub, etc.)
 *
 * @generated from message gitpod.v1.IntegrationDefinition
 */
export class IntegrationDefinition extends Message<IntegrationDefinition> {
  /**
   * id is the unique identifier for this integration definition
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * name is the human-readable name for this integration type
   *
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * description provides a human-readable description of the integration
   *
   * @generated from field: string description = 3;
   */
  description = "";

  /**
   * icon_url is the URL for this integration's icon
   *
   * @generated from field: string icon_url = 4;
   */
  iconUrl = "";

  /**
   * capabilities defines what this integration can do
   *
   * @generated from field: gitpod.v1.IntegrationCapabilities capabilities = 5;
   */
  capabilities?: IntegrationCapabilities;

  /**
   * auth defines the authentication requirements for this integration
   *
   * @generated from field: gitpod.v1.IntegrationAuthentication auth = 6;
   */
  auth?: IntegrationAuthentication;

  /**
   * host is the hostname for this integration (e.g., "linear.app")
   *
   * @generated from field: string host = 7;
   */
  host = "";

  /**
   * experimental indicates if this integration is experimental and requires feature flag
   *
   * @generated from field: bool experimental = 8;
   */
  experimental = false;

  constructor(data?: PartialMessage<IntegrationDefinition>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.IntegrationDefinition";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "capabilities", kind: "message", T: IntegrationCapabilities },
    { no: 6, name: "auth", kind: "message", T: IntegrationAuthentication },
    { no: 7, name: "host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "experimental", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IntegrationDefinition {
    return new IntegrationDefinition().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IntegrationDefinition {
    return new IntegrationDefinition().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IntegrationDefinition {
    return new IntegrationDefinition().fromJsonString(jsonString, options);
  }

  static equals(a: IntegrationDefinition | PlainMessage<IntegrationDefinition> | undefined, b: IntegrationDefinition | PlainMessage<IntegrationDefinition> | undefined): boolean {
    return proto3.util.equals(IntegrationDefinition, a, b);
  }
}

/**
 * IntegrationCapabilities defines what an integration can do
 *
 * @generated from message gitpod.v1.IntegrationCapabilities
 */
export class IntegrationCapabilities extends Message<IntegrationCapabilities> {
  /**
   * mcp configuration for Model Context Protocol support
   *
   * @generated from field: gitpod.v1.IntegrationMCPCapability mcp = 1;
   */
  mcp?: IntegrationMCPCapability;

  /**
   * context_parsing configuration for context parsing support
   *
   * @generated from field: gitpod.v1.IntegrationContextParsingCapability context_parsing = 2;
   */
  contextParsing?: IntegrationContextParsingCapability;

  /**
   * source_code_access configuration for source code access support
   *
   * @generated from field: gitpod.v1.IntegrationSourceCodeAccessCapability source_code_access = 3;
   */
  sourceCodeAccess?: IntegrationSourceCodeAccessCapability;

  /**
   * login configuration for login/authentication support
   *
   * @generated from field: gitpod.v1.IntegrationLoginCapability login = 4;
   */
  login?: IntegrationLoginCapability;

  /**
   * agent_client configuration for agent client functionality support
   *
   * @generated from field: gitpod.v1.IntegrationAgentClientCapability agent_client = 5;
   */
  agentClient?: IntegrationAgentClientCapability;

  constructor(data?: PartialMessage<IntegrationCapabilities>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.IntegrationCapabilities";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "mcp", kind: "message", T: IntegrationMCPCapability },
    { no: 2, name: "context_parsing", kind: "message", T: IntegrationContextParsingCapability },
    { no: 3, name: "source_code_access", kind: "message", T: IntegrationSourceCodeAccessCapability },
    { no: 4, name: "login", kind: "message", T: IntegrationLoginCapability },
    { no: 5, name: "agent_client", kind: "message", T: IntegrationAgentClientCapability },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IntegrationCapabilities {
    return new IntegrationCapabilities().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IntegrationCapabilities {
    return new IntegrationCapabilities().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IntegrationCapabilities {
    return new IntegrationCapabilities().fromJsonString(jsonString, options);
  }

  static equals(a: IntegrationCapabilities | PlainMessage<IntegrationCapabilities> | undefined, b: IntegrationCapabilities | PlainMessage<IntegrationCapabilities> | undefined): boolean {
    return proto3.util.equals(IntegrationCapabilities, a, b);
  }
}

/**
 * IntegrationMCPCapability defines Model Context Protocol capability
 *
 * @generated from message gitpod.v1.IntegrationMCPCapability
 */
export class IntegrationMCPCapability extends Message<IntegrationMCPCapability> {
  /**
   * url is the remote server URL for the MCP server
   *
   * @generated from field: string url = 1;
   */
  url = "";

  constructor(data?: PartialMessage<IntegrationMCPCapability>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.IntegrationMCPCapability";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IntegrationMCPCapability {
    return new IntegrationMCPCapability().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IntegrationMCPCapability {
    return new IntegrationMCPCapability().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IntegrationMCPCapability {
    return new IntegrationMCPCapability().fromJsonString(jsonString, options);
  }

  static equals(a: IntegrationMCPCapability | PlainMessage<IntegrationMCPCapability> | undefined, b: IntegrationMCPCapability | PlainMessage<IntegrationMCPCapability> | undefined): boolean {
    return proto3.util.equals(IntegrationMCPCapability, a, b);
  }
}

/**
 * IntegrationContextParsingCapability defines context parsing capability
 *
 * Additional context parsing configuration can be added here
 *
 * @generated from message gitpod.v1.IntegrationContextParsingCapability
 */
export class IntegrationContextParsingCapability extends Message<IntegrationContextParsingCapability> {
  constructor(data?: PartialMessage<IntegrationContextParsingCapability>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.IntegrationContextParsingCapability";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IntegrationContextParsingCapability {
    return new IntegrationContextParsingCapability().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IntegrationContextParsingCapability {
    return new IntegrationContextParsingCapability().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IntegrationContextParsingCapability {
    return new IntegrationContextParsingCapability().fromJsonString(jsonString, options);
  }

  static equals(a: IntegrationContextParsingCapability | PlainMessage<IntegrationContextParsingCapability> | undefined, b: IntegrationContextParsingCapability | PlainMessage<IntegrationContextParsingCapability> | undefined): boolean {
    return proto3.util.equals(IntegrationContextParsingCapability, a, b);
  }
}

/**
 * IntegrationSourceCodeAccessCapability defines source code access capability
 *
 * Additional source code access configuration can be added here
 *
 * @generated from message gitpod.v1.IntegrationSourceCodeAccessCapability
 */
export class IntegrationSourceCodeAccessCapability extends Message<IntegrationSourceCodeAccessCapability> {
  constructor(data?: PartialMessage<IntegrationSourceCodeAccessCapability>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.IntegrationSourceCodeAccessCapability";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IntegrationSourceCodeAccessCapability {
    return new IntegrationSourceCodeAccessCapability().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IntegrationSourceCodeAccessCapability {
    return new IntegrationSourceCodeAccessCapability().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IntegrationSourceCodeAccessCapability {
    return new IntegrationSourceCodeAccessCapability().fromJsonString(jsonString, options);
  }

  static equals(a: IntegrationSourceCodeAccessCapability | PlainMessage<IntegrationSourceCodeAccessCapability> | undefined, b: IntegrationSourceCodeAccessCapability | PlainMessage<IntegrationSourceCodeAccessCapability> | undefined): boolean {
    return proto3.util.equals(IntegrationSourceCodeAccessCapability, a, b);
  }
}

/**
 * IntegrationLoginCapability defines login/authentication capability
 *
 * Additional login configuration can be added here
 *
 * @generated from message gitpod.v1.IntegrationLoginCapability
 */
export class IntegrationLoginCapability extends Message<IntegrationLoginCapability> {
  constructor(data?: PartialMessage<IntegrationLoginCapability>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.IntegrationLoginCapability";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IntegrationLoginCapability {
    return new IntegrationLoginCapability().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IntegrationLoginCapability {
    return new IntegrationLoginCapability().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IntegrationLoginCapability {
    return new IntegrationLoginCapability().fromJsonString(jsonString, options);
  }

  static equals(a: IntegrationLoginCapability | PlainMessage<IntegrationLoginCapability> | undefined, b: IntegrationLoginCapability | PlainMessage<IntegrationLoginCapability> | undefined): boolean {
    return proto3.util.equals(IntegrationLoginCapability, a, b);
  }
}

/**
 * IntegrationAgentClientCapability indicates the integration supports agent client functionality.
 * The webhook signing secret is stored in IntegrationProprietaryAppConfig.webhook_secret.
 *
 * Empty - presence of this capability indicates agent client support
 *
 * @generated from message gitpod.v1.IntegrationAgentClientCapability
 */
export class IntegrationAgentClientCapability extends Message<IntegrationAgentClientCapability> {
  constructor(data?: PartialMessage<IntegrationAgentClientCapability>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.IntegrationAgentClientCapability";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IntegrationAgentClientCapability {
    return new IntegrationAgentClientCapability().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IntegrationAgentClientCapability {
    return new IntegrationAgentClientCapability().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IntegrationAgentClientCapability {
    return new IntegrationAgentClientCapability().fromJsonString(jsonString, options);
  }

  static equals(a: IntegrationAgentClientCapability | PlainMessage<IntegrationAgentClientCapability> | undefined, b: IntegrationAgentClientCapability | PlainMessage<IntegrationAgentClientCapability> | undefined): boolean {
    return proto3.util.equals(IntegrationAgentClientCapability, a, b);
  }
}

/**
 * IntegrationAuthentication defines authentication requirements and options
 *
 * @generated from message gitpod.v1.IntegrationAuthentication
 */
export class IntegrationAuthentication extends Message<IntegrationAuthentication> {
  /**
   * requires_auth indicates if authentication is required for this integration
   *
   * @generated from field: bool requires_auth = 1;
   */
  requiresAuth = false;

  /**
   * api_key configuration if API key authentication is supported
   *
   * @generated from field: gitpod.v1.IntegrationAPIKeyConfig api_key = 2;
   */
  apiKey?: IntegrationAPIKeyConfig;

  /**
   * oauth configuration if OAuth authentication is supported
   *
   * @generated from field: gitpod.v1.IntegrationOAuthConfig oauth = 3;
   */
  oauth?: IntegrationOAuthConfig;

  /**
   * proprietary configuration if supported
   *
   * @generated from field: gitpod.v1.IntegrationProprietaryAppConfig proprietary_app = 4;
   */
  proprietaryApp?: IntegrationProprietaryAppConfig;

  constructor(data?: PartialMessage<IntegrationAuthentication>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.IntegrationAuthentication";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "requires_auth", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "api_key", kind: "message", T: IntegrationAPIKeyConfig },
    { no: 3, name: "oauth", kind: "message", T: IntegrationOAuthConfig },
    { no: 4, name: "proprietary_app", kind: "message", T: IntegrationProprietaryAppConfig },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IntegrationAuthentication {
    return new IntegrationAuthentication().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IntegrationAuthentication {
    return new IntegrationAuthentication().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IntegrationAuthentication {
    return new IntegrationAuthentication().fromJsonString(jsonString, options);
  }

  static equals(a: IntegrationAuthentication | PlainMessage<IntegrationAuthentication> | undefined, b: IntegrationAuthentication | PlainMessage<IntegrationAuthentication> | undefined): boolean {
    return proto3.util.equals(IntegrationAuthentication, a, b);
  }
}

/**
 * IntegrationAPIKeyConfig defines API key authentication configuration
 *
 * Additional API key configuration can be added here
 *
 * @generated from message gitpod.v1.IntegrationAPIKeyConfig
 */
export class IntegrationAPIKeyConfig extends Message<IntegrationAPIKeyConfig> {
  constructor(data?: PartialMessage<IntegrationAPIKeyConfig>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.IntegrationAPIKeyConfig";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IntegrationAPIKeyConfig {
    return new IntegrationAPIKeyConfig().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IntegrationAPIKeyConfig {
    return new IntegrationAPIKeyConfig().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IntegrationAPIKeyConfig {
    return new IntegrationAPIKeyConfig().fromJsonString(jsonString, options);
  }

  static equals(a: IntegrationAPIKeyConfig | PlainMessage<IntegrationAPIKeyConfig> | undefined, b: IntegrationAPIKeyConfig | PlainMessage<IntegrationAPIKeyConfig> | undefined): boolean {
    return proto3.util.equals(IntegrationAPIKeyConfig, a, b);
  }
}

/**
 * IntegrationOAuthConfig defines OAuth-specific configuration
 *
 * @generated from message gitpod.v1.IntegrationOAuthConfig
 */
export class IntegrationOAuthConfig extends Message<IntegrationOAuthConfig> {
  /**
   * auth_url is the OAuth authorization endpoint URL
   *
   * @generated from field: string auth_url = 1;
   */
  authUrl = "";

  /**
   * token_url is the OAuth token endpoint URL
   *
   * @generated from field: string token_url = 2;
   */
  tokenUrl = "";

  /**
   * scopes are the OAuth scopes to request
   *
   * @generated from field: repeated string scopes = 3;
   */
  scopes: string[] = [];

  /**
   * client_id is the OAuth client ID (optional if dynamic_registration is enabled)
   *
   * @generated from field: string client_id = 4;
   */
  clientId = "";

  /**
   * client_secret is the OAuth client secret (optional for public clients)
   *
   * @generated from field: string client_secret = 5;
   */
  clientSecret = "";

  /**
   * redirect_url is the OAuth callback/redirect URL
   *
   * @generated from field: string redirect_url = 6;
   */
  redirectUrl = "";

  /**
   * dynamic_registration enables RFC 7591 OAuth 2.0 Dynamic Client Registration.
   * When enabled, client credentials are obtained automatically from the authorization
   * server's registration endpoint (discovered via RFC 8414 metadata).
   * When disabled (default), client_id and client_secret must be pre-configured.
   *
   * @generated from field: bool dynamic_registration = 7;
   */
  dynamicRegistration = false;

  /**
   * auth_params are additional query parameters to include in the OAuth
   * authorization URL. Use comma-separated values for multi-value params
   * (e.g., "search:read,chat:write" for Slack's user_scope).
   *
   * @generated from field: map<string, string> auth_params = 8;
   */
  authParams: { [key: string]: string } = {};

  constructor(data?: PartialMessage<IntegrationOAuthConfig>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.IntegrationOAuthConfig";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "auth_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "token_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "scopes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "client_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "client_secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "dynamic_registration", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "auth_params", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IntegrationOAuthConfig {
    return new IntegrationOAuthConfig().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IntegrationOAuthConfig {
    return new IntegrationOAuthConfig().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IntegrationOAuthConfig {
    return new IntegrationOAuthConfig().fromJsonString(jsonString, options);
  }

  static equals(a: IntegrationOAuthConfig | PlainMessage<IntegrationOAuthConfig> | undefined, b: IntegrationOAuthConfig | PlainMessage<IntegrationOAuthConfig> | undefined): boolean {
    return proto3.util.equals(IntegrationOAuthConfig, a, b);
  }
}

/**
 * IntegrationProprietaryAppConfig defines proprietary application integration configuration.
 * Used for app installations that interact with Ona (e.g., GitHub Apps, Linear agent apps).
 *
 * @generated from message gitpod.v1.IntegrationProprietaryAppConfig
 */
export class IntegrationProprietaryAppConfig extends Message<IntegrationProprietaryAppConfig> {
  /**
   * client_id is the app client ID
   *
   * @generated from field: string client_id = 1;
   */
  clientId = "";

  /**
   * client_secret is the app client secret
   *
   * @generated from field: string client_secret = 2;
   */
  clientSecret = "";

  /**
   * webhook_secret is the secret used to verify webhook signatures from the app provider
   *
   * @generated from field: string webhook_secret = 3;
   */
  webhookSecret = "";

  /**
   * auth_params are additional OAuth authorization parameters to include in the auth URL.
   * Example: {"actor": "app"} for Linear agent installations.
   *
   * @generated from field: map<string, string> auth_params = 4;
   */
  authParams: { [key: string]: string } = {};

  /**
   * app_scopes are OAuth scopes to request when using app installation flows.
   * If not set, falls back to the standard OAuth scopes.
   *
   * @generated from field: repeated string app_scopes = 5;
   */
  appScopes: string[] = [];

  constructor(data?: PartialMessage<IntegrationProprietaryAppConfig>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.IntegrationProprietaryAppConfig";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "client_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "client_secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "webhook_secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "auth_params", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 5, name: "app_scopes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IntegrationProprietaryAppConfig {
    return new IntegrationProprietaryAppConfig().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IntegrationProprietaryAppConfig {
    return new IntegrationProprietaryAppConfig().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IntegrationProprietaryAppConfig {
    return new IntegrationProprietaryAppConfig().fromJsonString(jsonString, options);
  }

  static equals(a: IntegrationProprietaryAppConfig | PlainMessage<IntegrationProprietaryAppConfig> | undefined, b: IntegrationProprietaryAppConfig | PlainMessage<IntegrationProprietaryAppConfig> | undefined): boolean {
    return proto3.util.equals(IntegrationProprietaryAppConfig, a, b);
  }
}

/**
 * Integration represents an instantiated integration within an organization
 *
 * @generated from message gitpod.v1.Integration
 */
export class Integration extends Message<Integration> {
  /**
   * id is the unique identifier for this integration instance
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * organization_id is the organization this integration belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId = "";

  /**
   * integration_definition_id references the integration definition ID
   *
   * @generated from field: string integration_definition_id = 3;
   */
  integrationDefinitionId = "";

  /**
   * enabled indicates if this integration is currently enabled
   *
   * @generated from field: bool enabled = 4;
   */
  enabled = false;

  /**
   * capabilities defines which capabilities are enabled for this integration
   *
   * @generated from field: gitpod.v1.IntegrationCapabilities capabilities = 5;
   */
  capabilities?: IntegrationCapabilities;

  /**
   * runner_id - if set, restricts integration to specific runner
   *
   * @generated from field: string runner_id = 6;
   */
  runnerId = "";

  /**
   * auth defines which authentication methods are enabled for this integration
   *
   * @generated from field: gitpod.v1.IntegrationAuthentication auth = 7;
   */
  auth?: IntegrationAuthentication;

  /**
   * host is the hostname for this integration (e.g., "linear.app") - optional, inherits from definition
   *
   * @generated from field: string host = 8;
   */
  host = "";

  constructor(data?: PartialMessage<Integration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.Integration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "integration_definition_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "capabilities", kind: "message", T: IntegrationCapabilities },
    { no: 6, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "auth", kind: "message", T: IntegrationAuthentication },
    { no: 8, name: "host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Integration {
    return new Integration().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Integration {
    return new Integration().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Integration {
    return new Integration().fromJsonString(jsonString, options);
  }

  static equals(a: Integration | PlainMessage<Integration> | undefined, b: Integration | PlainMessage<Integration> | undefined): boolean {
    return proto3.util.equals(Integration, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListIntegrationDefinitionsRequest
 */
export class ListIntegrationDefinitionsRequest extends Message<ListIntegrationDefinitionsRequest> {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  constructor(data?: PartialMessage<ListIntegrationDefinitionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListIntegrationDefinitionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListIntegrationDefinitionsRequest {
    return new ListIntegrationDefinitionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListIntegrationDefinitionsRequest {
    return new ListIntegrationDefinitionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListIntegrationDefinitionsRequest {
    return new ListIntegrationDefinitionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListIntegrationDefinitionsRequest | PlainMessage<ListIntegrationDefinitionsRequest> | undefined, b: ListIntegrationDefinitionsRequest | PlainMessage<ListIntegrationDefinitionsRequest> | undefined): boolean {
    return proto3.util.equals(ListIntegrationDefinitionsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListIntegrationDefinitionsResponse
 */
export class ListIntegrationDefinitionsResponse extends Message<ListIntegrationDefinitionsResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.IntegrationDefinition definitions = 2;
   */
  definitions: IntegrationDefinition[] = [];

  constructor(data?: PartialMessage<ListIntegrationDefinitionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListIntegrationDefinitionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "definitions", kind: "message", T: IntegrationDefinition, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListIntegrationDefinitionsResponse {
    return new ListIntegrationDefinitionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListIntegrationDefinitionsResponse {
    return new ListIntegrationDefinitionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListIntegrationDefinitionsResponse {
    return new ListIntegrationDefinitionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListIntegrationDefinitionsResponse | PlainMessage<ListIntegrationDefinitionsResponse> | undefined, b: ListIntegrationDefinitionsResponse | PlainMessage<ListIntegrationDefinitionsResponse> | undefined): boolean {
    return proto3.util.equals(ListIntegrationDefinitionsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateIntegrationRequest
 */
export class CreateIntegrationRequest extends Message<CreateIntegrationRequest> {
  /**
   * integration_definition_id references the integration definition ID
   *
   * @generated from field: string integration_definition_id = 1;
   */
  integrationDefinitionId = "";

  /**
   * runner_id is optional and immutable - if provided, restricts integration to specific runner
   *
   * @generated from field: string runner_id = 2;
   */
  runnerId = "";

  /**
   * enabled indicates if this integration is enabled
   *
   * @generated from field: bool enabled = 3;
   */
  enabled = false;

  /**
   * capabilities defines which capabilities are enabled for this integration
   *
   * @generated from field: gitpod.v1.IntegrationCapabilities capabilities = 4;
   */
  capabilities?: IntegrationCapabilities;

  /**
   * auth defines which authentication methods are enabled for this integration
   *
   * @generated from field: gitpod.v1.IntegrationAuthentication auth = 5;
   */
  auth?: IntegrationAuthentication;

  /**
   * host is the hostname for this integration (e.g., "linear.app") - optional, inherits from definition
   *
   * @generated from field: string host = 6;
   */
  host = "";

  constructor(data?: PartialMessage<CreateIntegrationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateIntegrationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "integration_definition_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "capabilities", kind: "message", T: IntegrationCapabilities },
    { no: 5, name: "auth", kind: "message", T: IntegrationAuthentication },
    { no: 6, name: "host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateIntegrationRequest {
    return new CreateIntegrationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateIntegrationRequest {
    return new CreateIntegrationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateIntegrationRequest {
    return new CreateIntegrationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateIntegrationRequest | PlainMessage<CreateIntegrationRequest> | undefined, b: CreateIntegrationRequest | PlainMessage<CreateIntegrationRequest> | undefined): boolean {
    return proto3.util.equals(CreateIntegrationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateIntegrationResponse
 */
export class CreateIntegrationResponse extends Message<CreateIntegrationResponse> {
  /**
   * @generated from field: gitpod.v1.Integration integration = 1;
   */
  integration?: Integration;

  constructor(data?: PartialMessage<CreateIntegrationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateIntegrationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "integration", kind: "message", T: Integration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateIntegrationResponse {
    return new CreateIntegrationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateIntegrationResponse {
    return new CreateIntegrationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateIntegrationResponse {
    return new CreateIntegrationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateIntegrationResponse | PlainMessage<CreateIntegrationResponse> | undefined, b: CreateIntegrationResponse | PlainMessage<CreateIntegrationResponse> | undefined): boolean {
    return proto3.util.equals(CreateIntegrationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetIntegrationRequest
 */
export class GetIntegrationRequest extends Message<GetIntegrationRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetIntegrationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetIntegrationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetIntegrationRequest {
    return new GetIntegrationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetIntegrationRequest {
    return new GetIntegrationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetIntegrationRequest {
    return new GetIntegrationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetIntegrationRequest | PlainMessage<GetIntegrationRequest> | undefined, b: GetIntegrationRequest | PlainMessage<GetIntegrationRequest> | undefined): boolean {
    return proto3.util.equals(GetIntegrationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetIntegrationResponse
 */
export class GetIntegrationResponse extends Message<GetIntegrationResponse> {
  /**
   * @generated from field: gitpod.v1.Integration integration = 1;
   */
  integration?: Integration;

  constructor(data?: PartialMessage<GetIntegrationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetIntegrationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "integration", kind: "message", T: Integration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetIntegrationResponse {
    return new GetIntegrationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetIntegrationResponse {
    return new GetIntegrationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetIntegrationResponse {
    return new GetIntegrationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetIntegrationResponse | PlainMessage<GetIntegrationResponse> | undefined, b: GetIntegrationResponse | PlainMessage<GetIntegrationResponse> | undefined): boolean {
    return proto3.util.equals(GetIntegrationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateIntegrationRequest
 */
export class UpdateIntegrationRequest extends Message<UpdateIntegrationRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * enabled indicates if this integration is enabled
   *
   * @generated from field: optional bool enabled = 2;
   */
  enabled?: boolean;

  /**
   * capabilities defines which capabilities are enabled for this integration
   *
   * @generated from field: optional gitpod.v1.IntegrationCapabilities capabilities = 3;
   */
  capabilities?: IntegrationCapabilities;

  /**
   * auth defines which authentication methods are enabled for this integration
   *
   * @generated from field: optional gitpod.v1.IntegrationAuthentication auth = 4;
   */
  auth?: IntegrationAuthentication;

  /**
   * host is the hostname for this integration (e.g., "linear.app") - optional, inherits from definition
   *
   * @generated from field: optional string host = 5;
   */
  host?: string;

  constructor(data?: PartialMessage<UpdateIntegrationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateIntegrationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 3, name: "capabilities", kind: "message", T: IntegrationCapabilities, opt: true },
    { no: 4, name: "auth", kind: "message", T: IntegrationAuthentication, opt: true },
    { no: 5, name: "host", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateIntegrationRequest {
    return new UpdateIntegrationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateIntegrationRequest {
    return new UpdateIntegrationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateIntegrationRequest {
    return new UpdateIntegrationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateIntegrationRequest | PlainMessage<UpdateIntegrationRequest> | undefined, b: UpdateIntegrationRequest | PlainMessage<UpdateIntegrationRequest> | undefined): boolean {
    return proto3.util.equals(UpdateIntegrationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateIntegrationResponse
 */
export class UpdateIntegrationResponse extends Message<UpdateIntegrationResponse> {
  /**
   * @generated from field: gitpod.v1.Integration integration = 1;
   */
  integration?: Integration;

  constructor(data?: PartialMessage<UpdateIntegrationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateIntegrationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "integration", kind: "message", T: Integration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateIntegrationResponse {
    return new UpdateIntegrationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateIntegrationResponse {
    return new UpdateIntegrationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateIntegrationResponse {
    return new UpdateIntegrationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateIntegrationResponse | PlainMessage<UpdateIntegrationResponse> | undefined, b: UpdateIntegrationResponse | PlainMessage<UpdateIntegrationResponse> | undefined): boolean {
    return proto3.util.equals(UpdateIntegrationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteIntegrationRequest
 */
export class DeleteIntegrationRequest extends Message<DeleteIntegrationRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<DeleteIntegrationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteIntegrationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteIntegrationRequest {
    return new DeleteIntegrationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteIntegrationRequest {
    return new DeleteIntegrationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteIntegrationRequest {
    return new DeleteIntegrationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteIntegrationRequest | PlainMessage<DeleteIntegrationRequest> | undefined, b: DeleteIntegrationRequest | PlainMessage<DeleteIntegrationRequest> | undefined): boolean {
    return proto3.util.equals(DeleteIntegrationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteIntegrationResponse
 */
export class DeleteIntegrationResponse extends Message<DeleteIntegrationResponse> {
  constructor(data?: PartialMessage<DeleteIntegrationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteIntegrationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteIntegrationResponse {
    return new DeleteIntegrationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteIntegrationResponse {
    return new DeleteIntegrationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteIntegrationResponse {
    return new DeleteIntegrationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteIntegrationResponse | PlainMessage<DeleteIntegrationResponse> | undefined, b: DeleteIntegrationResponse | PlainMessage<DeleteIntegrationResponse> | undefined): boolean {
    return proto3.util.equals(DeleteIntegrationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListIntegrationsRequest
 */
export class ListIntegrationsRequest extends Message<ListIntegrationsRequest> {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  constructor(data?: PartialMessage<ListIntegrationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListIntegrationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListIntegrationsRequest {
    return new ListIntegrationsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListIntegrationsRequest {
    return new ListIntegrationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListIntegrationsRequest {
    return new ListIntegrationsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListIntegrationsRequest | PlainMessage<ListIntegrationsRequest> | undefined, b: ListIntegrationsRequest | PlainMessage<ListIntegrationsRequest> | undefined): boolean {
    return proto3.util.equals(ListIntegrationsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListIntegrationsResponse
 */
export class ListIntegrationsResponse extends Message<ListIntegrationsResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.Integration integrations = 2;
   */
  integrations: Integration[] = [];

  constructor(data?: PartialMessage<ListIntegrationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListIntegrationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "integrations", kind: "message", T: Integration, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListIntegrationsResponse {
    return new ListIntegrationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListIntegrationsResponse {
    return new ListIntegrationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListIntegrationsResponse {
    return new ListIntegrationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListIntegrationsResponse | PlainMessage<ListIntegrationsResponse> | undefined, b: ListIntegrationsResponse | PlainMessage<ListIntegrationsResponse> | undefined): boolean {
    return proto3.util.equals(ListIntegrationsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateIntegrationDefinitionRequest
 */
export class CreateIntegrationDefinitionRequest extends Message<CreateIntegrationDefinitionRequest> {
  /**
   * name is the human-readable name for this integration type
   *
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * description provides a human-readable description of the integration
   *
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * icon_url is the URL for this integration's icon
   *
   * @generated from field: string icon_url = 3;
   */
  iconUrl = "";

  /**
   * capabilities defines what this integration can do
   *
   * @generated from field: gitpod.v1.IntegrationCapabilities capabilities = 4;
   */
  capabilities?: IntegrationCapabilities;

  /**
   * auth defines the authentication requirements for this integration
   *
   * @generated from field: gitpod.v1.IntegrationAuthentication auth = 5;
   */
  auth?: IntegrationAuthentication;

  /**
   * host is the hostname for this integration (e.g., "linear.app")
   *
   * @generated from field: string host = 6;
   */
  host = "";

  /**
   * experimental indicates if this integration is experimental and requires feature flag
   *
   * @generated from field: bool experimental = 7;
   */
  experimental = false;

  constructor(data?: PartialMessage<CreateIntegrationDefinitionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateIntegrationDefinitionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "capabilities", kind: "message", T: IntegrationCapabilities },
    { no: 5, name: "auth", kind: "message", T: IntegrationAuthentication },
    { no: 6, name: "host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "experimental", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateIntegrationDefinitionRequest {
    return new CreateIntegrationDefinitionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateIntegrationDefinitionRequest {
    return new CreateIntegrationDefinitionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateIntegrationDefinitionRequest {
    return new CreateIntegrationDefinitionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateIntegrationDefinitionRequest | PlainMessage<CreateIntegrationDefinitionRequest> | undefined, b: CreateIntegrationDefinitionRequest | PlainMessage<CreateIntegrationDefinitionRequest> | undefined): boolean {
    return proto3.util.equals(CreateIntegrationDefinitionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateIntegrationDefinitionResponse
 */
export class CreateIntegrationDefinitionResponse extends Message<CreateIntegrationDefinitionResponse> {
  /**
   * @generated from field: gitpod.v1.IntegrationDefinition definition = 1;
   */
  definition?: IntegrationDefinition;

  constructor(data?: PartialMessage<CreateIntegrationDefinitionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateIntegrationDefinitionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "definition", kind: "message", T: IntegrationDefinition },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateIntegrationDefinitionResponse {
    return new CreateIntegrationDefinitionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateIntegrationDefinitionResponse {
    return new CreateIntegrationDefinitionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateIntegrationDefinitionResponse {
    return new CreateIntegrationDefinitionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateIntegrationDefinitionResponse | PlainMessage<CreateIntegrationDefinitionResponse> | undefined, b: CreateIntegrationDefinitionResponse | PlainMessage<CreateIntegrationDefinitionResponse> | undefined): boolean {
    return proto3.util.equals(CreateIntegrationDefinitionResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetIntegrationDefinitionRequest
 */
export class GetIntegrationDefinitionRequest extends Message<GetIntegrationDefinitionRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetIntegrationDefinitionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetIntegrationDefinitionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetIntegrationDefinitionRequest {
    return new GetIntegrationDefinitionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetIntegrationDefinitionRequest {
    return new GetIntegrationDefinitionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetIntegrationDefinitionRequest {
    return new GetIntegrationDefinitionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetIntegrationDefinitionRequest | PlainMessage<GetIntegrationDefinitionRequest> | undefined, b: GetIntegrationDefinitionRequest | PlainMessage<GetIntegrationDefinitionRequest> | undefined): boolean {
    return proto3.util.equals(GetIntegrationDefinitionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetIntegrationDefinitionResponse
 */
export class GetIntegrationDefinitionResponse extends Message<GetIntegrationDefinitionResponse> {
  /**
   * @generated from field: gitpod.v1.IntegrationDefinition definition = 1;
   */
  definition?: IntegrationDefinition;

  constructor(data?: PartialMessage<GetIntegrationDefinitionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetIntegrationDefinitionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "definition", kind: "message", T: IntegrationDefinition },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetIntegrationDefinitionResponse {
    return new GetIntegrationDefinitionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetIntegrationDefinitionResponse {
    return new GetIntegrationDefinitionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetIntegrationDefinitionResponse {
    return new GetIntegrationDefinitionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetIntegrationDefinitionResponse | PlainMessage<GetIntegrationDefinitionResponse> | undefined, b: GetIntegrationDefinitionResponse | PlainMessage<GetIntegrationDefinitionResponse> | undefined): boolean {
    return proto3.util.equals(GetIntegrationDefinitionResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateIntegrationDefinitionRequest
 */
export class UpdateIntegrationDefinitionRequest extends Message<UpdateIntegrationDefinitionRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * name is the human-readable name for this integration type
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * description provides a human-readable description of the integration
   *
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * icon_url is the URL for this integration's icon
   *
   * @generated from field: optional string icon_url = 4;
   */
  iconUrl?: string;

  /**
   * capabilities defines what this integration can do
   *
   * @generated from field: optional gitpod.v1.IntegrationCapabilities capabilities = 5;
   */
  capabilities?: IntegrationCapabilities;

  /**
   * auth defines the authentication requirements for this integration
   *
   * @generated from field: optional gitpod.v1.IntegrationAuthentication auth = 6;
   */
  auth?: IntegrationAuthentication;

  /**
   * host is the hostname for this integration (e.g., "linear.app")
   *
   * @generated from field: optional string host = 7;
   */
  host?: string;

  /**
   * experimental indicates if this integration is experimental and requires feature flag
   *
   * @generated from field: optional bool experimental = 8;
   */
  experimental?: boolean;

  constructor(data?: PartialMessage<UpdateIntegrationDefinitionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateIntegrationDefinitionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "capabilities", kind: "message", T: IntegrationCapabilities, opt: true },
    { no: 6, name: "auth", kind: "message", T: IntegrationAuthentication, opt: true },
    { no: 7, name: "host", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "experimental", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateIntegrationDefinitionRequest {
    return new UpdateIntegrationDefinitionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateIntegrationDefinitionRequest {
    return new UpdateIntegrationDefinitionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateIntegrationDefinitionRequest {
    return new UpdateIntegrationDefinitionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateIntegrationDefinitionRequest | PlainMessage<UpdateIntegrationDefinitionRequest> | undefined, b: UpdateIntegrationDefinitionRequest | PlainMessage<UpdateIntegrationDefinitionRequest> | undefined): boolean {
    return proto3.util.equals(UpdateIntegrationDefinitionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateIntegrationDefinitionResponse
 */
export class UpdateIntegrationDefinitionResponse extends Message<UpdateIntegrationDefinitionResponse> {
  /**
   * @generated from field: gitpod.v1.IntegrationDefinition definition = 1;
   */
  definition?: IntegrationDefinition;

  constructor(data?: PartialMessage<UpdateIntegrationDefinitionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateIntegrationDefinitionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "definition", kind: "message", T: IntegrationDefinition },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateIntegrationDefinitionResponse {
    return new UpdateIntegrationDefinitionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateIntegrationDefinitionResponse {
    return new UpdateIntegrationDefinitionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateIntegrationDefinitionResponse {
    return new UpdateIntegrationDefinitionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateIntegrationDefinitionResponse | PlainMessage<UpdateIntegrationDefinitionResponse> | undefined, b: UpdateIntegrationDefinitionResponse | PlainMessage<UpdateIntegrationDefinitionResponse> | undefined): boolean {
    return proto3.util.equals(UpdateIntegrationDefinitionResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteIntegrationDefinitionRequest
 */
export class DeleteIntegrationDefinitionRequest extends Message<DeleteIntegrationDefinitionRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<DeleteIntegrationDefinitionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteIntegrationDefinitionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteIntegrationDefinitionRequest {
    return new DeleteIntegrationDefinitionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteIntegrationDefinitionRequest {
    return new DeleteIntegrationDefinitionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteIntegrationDefinitionRequest {
    return new DeleteIntegrationDefinitionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteIntegrationDefinitionRequest | PlainMessage<DeleteIntegrationDefinitionRequest> | undefined, b: DeleteIntegrationDefinitionRequest | PlainMessage<DeleteIntegrationDefinitionRequest> | undefined): boolean {
    return proto3.util.equals(DeleteIntegrationDefinitionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteIntegrationDefinitionResponse
 */
export class DeleteIntegrationDefinitionResponse extends Message<DeleteIntegrationDefinitionResponse> {
  constructor(data?: PartialMessage<DeleteIntegrationDefinitionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteIntegrationDefinitionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteIntegrationDefinitionResponse {
    return new DeleteIntegrationDefinitionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteIntegrationDefinitionResponse {
    return new DeleteIntegrationDefinitionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteIntegrationDefinitionResponse {
    return new DeleteIntegrationDefinitionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteIntegrationDefinitionResponse | PlainMessage<DeleteIntegrationDefinitionResponse> | undefined, b: DeleteIntegrationDefinitionResponse | PlainMessage<DeleteIntegrationDefinitionResponse> | undefined): boolean {
    return proto3.util.equals(DeleteIntegrationDefinitionResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ValidateIntegrationRequest
 */
export class ValidateIntegrationRequest extends Message<ValidateIntegrationRequest> {
  /**
   * @generated from field: string integration_id = 1;
   */
  integrationId = "";

  constructor(data?: PartialMessage<ValidateIntegrationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ValidateIntegrationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "integration_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ValidateIntegrationRequest {
    return new ValidateIntegrationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ValidateIntegrationRequest {
    return new ValidateIntegrationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ValidateIntegrationRequest {
    return new ValidateIntegrationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ValidateIntegrationRequest | PlainMessage<ValidateIntegrationRequest> | undefined, b: ValidateIntegrationRequest | PlainMessage<ValidateIntegrationRequest> | undefined): boolean {
    return proto3.util.equals(ValidateIntegrationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ValidateIntegrationResponse
 */
export class ValidateIntegrationResponse extends Message<ValidateIntegrationResponse> {
  /**
   * valid is true when all checks pass (convenience field).
   *
   * @generated from field: bool valid = 1;
   */
  valid = false;

  /**
   * checks contains the result of every check performed.
   * Passing checks have empty message and action_hint.
   *
   * @generated from field: repeated gitpod.v1.ValidationCheck checks = 2;
   */
  checks: ValidationCheck[] = [];

  constructor(data?: PartialMessage<ValidateIntegrationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ValidateIntegrationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "valid", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "checks", kind: "message", T: ValidationCheck, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ValidateIntegrationResponse {
    return new ValidateIntegrationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ValidateIntegrationResponse {
    return new ValidateIntegrationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ValidateIntegrationResponse {
    return new ValidateIntegrationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ValidateIntegrationResponse | PlainMessage<ValidateIntegrationResponse> | undefined, b: ValidateIntegrationResponse | PlainMessage<ValidateIntegrationResponse> | undefined): boolean {
    return proto3.util.equals(ValidateIntegrationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ValidationCheck
 */
export class ValidationCheck extends Message<ValidationCheck> {
  /**
   * Which check this result is for.
   *
   * @generated from field: gitpod.v1.ValidationCheck.Check check = 1;
   */
  check = ValidationCheck_Check.UNSPECIFIED;

  /**
   * Human-readable description of the problem. Empty when the check passes.
   *
   * @generated from field: string message = 2;
   */
  message = "";

  /**
   * Machine-readable hint the frontend uses to resolve the issue (e.g. "app_installation_oauth").
   * Empty when the check passes or no automated fix is available.
   *
   * @generated from field: string action_hint = 3;
   */
  actionHint = "";

  /**
   * URL to documentation explaining this check failure and resolution steps.
   * Empty when the check passes or no docs exist for this check.
   *
   * @generated from field: string documentation_url = 4;
   */
  documentationUrl = "";

  constructor(data?: PartialMessage<ValidationCheck>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ValidationCheck";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "check", kind: "enum", T: proto3.getEnumType(ValidationCheck_Check) },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "action_hint", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "documentation_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ValidationCheck {
    return new ValidationCheck().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ValidationCheck {
    return new ValidationCheck().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ValidationCheck {
    return new ValidationCheck().fromJsonString(jsonString, options);
  }

  static equals(a: ValidationCheck | PlainMessage<ValidationCheck> | undefined, b: ValidationCheck | PlainMessage<ValidationCheck> | undefined): boolean {
    return proto3.util.equals(ValidationCheck, a, b);
  }
}

/**
 * @generated from enum gitpod.v1.ValidationCheck.Check
 */
export enum ValidationCheck_Check {
  /**
   * @generated from enum value: CHECK_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CHECK_APP_TOKEN = 1;
   */
  APP_TOKEN = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(ValidationCheck_Check)
proto3.util.setEnumType(ValidationCheck_Check, "gitpod.v1.ValidationCheck.Check", [
  { no: 0, name: "CHECK_UNSPECIFIED" },
  { no: 1, name: "CHECK_APP_TOKEN" },
]);

